import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { StatusPill } from "@/pages/portal/PortalDashboard";

export default function PortalCases() {
    const [cases, setCases] = useState([]);
    useEffect(() => {
        api.get("/case-requests/me").then((r) => setCases(r.data)).catch(() => {});
    }, []);

    return (
        <div data-testid="portal-cases-page">
            <div className="flex items-center justify-between">
                <div>
                    <div className="label-tag">Your cases</div>
                    <h1 className="mt-3 font-display text-4xl md:text-5xl font-bold">All case requests</h1>
                </div>
                <Link to="/portal/new-request" className="px-5 py-3 rounded-full bg-gold-500 text-ink-900 text-sm font-bold uppercase tracking-wider hover:bg-gold-400">
                    New request
                </Link>
            </div>
            <div className="mt-10 bg-ink-900 border border-white/10 rounded-2xl overflow-hidden">
                <table className="w-full text-sm">
                    <thead className="bg-ink-800 text-xs uppercase tracking-[0.2em] text-white/50">
                        <tr>
                            <th className="text-left px-5 py-4">Title</th>
                            <th className="text-left px-5 py-4">Service</th>
                            <th className="text-left px-5 py-4">Urgency</th>
                            <th className="text-left px-5 py-4">Status</th>
                            <th className="text-left px-5 py-4">Opened</th>
                        </tr>
                    </thead>
                    <tbody>
                        {cases.length === 0 ? (
                            <tr><td colSpan={5} className="text-center text-white/50 py-10">No cases yet.</td></tr>
                        ) : cases.map((c) => (
                            <tr key={c.id} className="border-t border-white/10" data-testid={`case-row-${c.id}`}>
                                <td className="px-5 py-4">{c.title}</td>
                                <td className="px-5 py-4 text-white/60">{c.service_slug}</td>
                                <td className="px-5 py-4 capitalize text-white/70">{c.urgency}</td>
                                <td className="px-5 py-4"><StatusPill status={c.status} /></td>
                                <td className="px-5 py-4 text-white/50">{new Date(c.created_at).toLocaleDateString()}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
